const defaultPositionMarkerAttributes = {
    stroke: '#878787',
    selectable: false
};

module.exports = {
    defaultPositionMarkerAttributes
};
